<template>
  <div class="page_home">
    <div v-if="smVisible" class="sm-card">
      <div class="sm-card-header">
        <div style="display:flex;align-items:center">
          <el-image style="width:20px;height:20px;margin-right:6px" :src="require('@/assets/images/homeImages/smShield.png')"></el-image>
          <span class="sm-card-title">平台声明</span>
        </div>
        <el-image class="sm-card-close" @click="smVisible = false" style="width:16px;height:16px;cursor:pointer" :src="require('@/assets/images/homeImages/smClose.png')"></el-image>
      </div>
      <div class="sm-card-body">
        <div class="sm-card-text">
          <div class="sm-card-text-main">严防冒充平台客服<br>诱导跳转其他平台诈骗</div>
          <div class="sm-card-text-sub">请认准官方渠道，谨防受骗</div>
        </div>
        <el-image class="sm-card-illustration" :src="require('@/assets/images/homeImages/smShieldCheck.png')"></el-image>
      </div>
      <div class="sm-card-footer">
        <label class="sm-card-checkbox">
          <input type="checkbox" v-model="smNoRemindToday" /> 今日不再提醒
        </label>
        <el-button class="sm-card-btn" type="text" @click="sm()">查看详情 <i class="el-icon-arrow-right"></i></el-button>
      </div>
    </div>
    <div class="page_header">
      <div class="home_lunbo">
        <el-carousel height="390px">
          <el-carousel-item v-for="(items,index) in imagelist" :key="index">
            <el-image  @click="carouselClick(items)" :src="items.pictureUrl" style="width:100%;height:inherit" fit="fill"></el-image>
          </el-carousel-item>
        </el-carousel>
      </div>
    </div>

    <div class="page_content">
      <div class="home_content">
        <div style="width: calc(100% - 344px);background: #FFFFFF;;border-radius:  8px">
          <div class="ptjxxx" style="">
            <div style="display: flex;justify-content: left;align-items: center">
              <el-image style="width: 24px;height: 24px;margin-right: 12px" :src="require('@/assets/images/homeImages/xx.png')"></el-image>
              <div style="font-size: 24px;color: #F8901F;margin-right: 12px">平台交易信息</div>
              <div style="font-size: 14px;color: #C4AB90;">汇聚招标中标信息，洞悉市场交易动态</div>
            </div>
            <div style="font-size: 16px;color: #333333;cursor: pointer" @click="toPath('/about')" >查看全部 <i style="width: 14px;height: 14px" class="el-icon-d-arrow-right"></i></div>
          </div>
          <div style="padding: 24px">
            <div style="display: flex;justify-content: left;align-items: center;margin-bottom: 24px;flex-wrap: wrap">
              <div @click="switchGGType(item)" v-for="(item,index) in ggType" :key="'ggType:' + item.label" :style="{marginRight: (index + 1) === ggType.length ? '':' 13px',background:noticeQueryParam.ggAnnouncement === item.value ?'#0081F9' :'rgba(0,129,249,0.05)',color:noticeQueryParam.ggAnnouncement === item.value ?'#FFFFFF':'#46433E' }" style="padding: 6px 6px;border-radius: 4px 4px 4px 4px;border: 1px solid rgba(0,129,249,0.5);font-size: 17px;cursor: pointer;margin-bottom: 10px">
                {{ item.label }}
              </div>

            </div>
            <div style="display: flex;flex-direction: column">
              <div v-for="(item,index) in ggList" :key="item.id" :style="(index + 1) === ggList.length ? '':'margin-bottom:20px'" @click="ggDetail(item)">
                <div style="display: flex;justify-content: space-between;align-items: center;cursor: pointer" >
                  <div style="display: flex;justify-content: left;align-items: center">
                    <div style="padding:4px 8px;background: #FB323D;border-radius: 4px 4px 4px 4px;font-size: 14px;color: #FFFFFF;" :style="item.areaName ? '' : 'margin-right: 12px'" v-if="item.zoneId">专区</div>
                    <div style="font-size: 16px;color: #333333;font-weight: 400;" v-if="item.areaName">【{{ item.areaName }}】</div>
                    <div style="font-size: 16px;color: #333333;font-weight: 400;">{{ item.ggName.length > 40 ? item.ggName.substring(0,40) + '...' : item.ggName }}</div>
                  </div>
                  <div>{{ item.ggStartTime.substring(0,10) }}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div style="width: 328px;">
          <div class="xtdlrk">
            <div style="display:flex;justify-content: left;align-items: center">
              <el-image style="width: 24px;height: 24px;margin-right: 12px" :src="require('@/assets/images/homeImages/dlrk.png')"></el-image>
              <div style="font-size: 24px;color: #F8901F;margin-right: 12px">系统登录入口</div>
            </div>
          </div>
          <div style="padding: 16px 20px; background: #FFFFFF;">
            <div v-for="(item,index) in logOn" :key="index + 'logOn'" @click="logOnClick(item)">
              <div v-if="item.isShow" :style="(index + 1) % 5 === 0 ? '' : 'margin-bottom:16px'" style="height: 70px;" >
                <el-image style="width: 100%;height: 100%" :src="item.icon"></el-image>
              </div>
            </div>
          </div>
          <div style="height: 140px">
            <el-image @click="applyFor" style="width: 100%;height: 100%" :src="home.cgzq"></el-image>
          </div>
        </div>
      </div>
      <div class="card1" style="display: flex;justify-content: space-between;align-items: center;cursor: pointer">
        <div @click="toRouter('/bidEvaluationOffice')">
          <el-image  style="width: 672px;" :src="home.kpbs"></el-image>
        </div>
        <div @click="toRouter('/expert')">
          <el-image  style="width:660px" :src="home.pbzj"></el-image>
        </div>
      </div>

      <div class="home_content" >
        <div style="padding:  20px;width:calc(100% - 398px);background-color:#fff;box-sizing: border-box;">
          <div style="margin-bottom: 24px;">
            <div class="headerTitleClass2" >
              <h3>新闻公告</h3>
            </div>
          </div>
          <div>
            <ul class="scroll news_list">
              <li style="display: flex;flex-direction: row;margin-bottom: 22px;" v-for="(item, index) in xwlist" :key="index" @click="goNewsDetail(item.id)">
                <div style="width: 15%;height:15%; margin-right: 20px;">
                  <div class="block">
                    <el-image :src="item.industrytupianUrl">
                      <div slot="error" class="image-slot">
                        <el-image :src="require('../../assets/images/xw.png')"></el-image>
                      </div>
                    </el-image>
                  </div>
                </div>
                <div style="width: 80%; display: flex;flex-direction: column;justify-content: space-around;">
                  <p class="con_h">{{ item.title }}</p>
                  <p class="flex_content"><span>{{ item.createTime.substring(0, 10) }}</span></p>
                </div>
              </li>
            </ul>
          </div>
        </div>
        <div style="width: 374px;box-sizing: border-box;">
          <div  style="background-color:#fff;">
            <div style="padding: 20px 0 0px 20px;">
              <div class="headerTitleClass2" >
                <h3>工具下载</h3>
              </div>
            </div>
            <div style="padding: 10px">
              <div   v-for="(item, index) in toollist"  :key="index">
                <div :class="{'toolitem':true}" @click="downloadClick(item,index)">
                  <div style="display: flex;justify-content: left;align-items: center;">
                    <el-image  style="width: 64px;height: 64px;margin-right: 12px" :src="item.imageUrl"></el-image>
                    <div>
                      <div style="font-size: 18px;color: #333333;">{{ item.commonName }}</div>
                      <el-button style="font-size: 14px;color: #165DFF; " type="text" >点击下载</el-button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div style="width: 374px;height: 280px">
            <el-image @click="applyForhz" style="width: 100%;height: 100%" :src="home.qyhzs"></el-image>
          </div>
        </div>
      </div>
    </div>
    <el-dialog center title="选择采购专区"  :visible.sync="registerDiong" width="1080px" append-to-body>
      <div style="display: flex;justify-content:left;align-items: center;flex-wrap: wrap;margin-bottom: 40px">
        <div v-for="(item,index) in specialZoneList.slice(0,1)" :key="item.id" :style="(index + 1) %5 === 0 ? '' : 'margin-right: 24px'" @click="switchZone(item)">
          <div style="width: 180px;height: 64px;border-radius: 2px 2px 2px 2px;border: 1px solid #DCDCDC;position: relative;overflow: hidden"  >
            <div class="isSelected" v-if="registerList.zoneId === item.id" style=""></div>
            <div>
              <div v-if="item.id === '0'">
                <img :src="item.navigationLogo">
              </div>
              <Picture v-else :file-id="item.navigationLogo" style="width: 100%;height: 100%"></Picture>
            </div>
          </div>
        </div>
      </div>
      <div style="margin-bottom: 48px">
        <div style="display: flex;justify-content: space-between;align-items: center;margin-bottom: 16px;cursor: pointer" @click="foldType = !foldType">
          <div style="font-size: 18px;color: #333333;">其它业主采购专区</div>
          <div style="display: flex;justify-content: center;align-items: center;font-size: 18px;color: #999999;">
            {{ foldType ? '收起' : '展开' }} <i v-if="foldType" class="el-icon-caret-top"></i> <i v-if="!foldType" class="el-icon-caret-bottom"></i>
          </div>
        </div>
        <div v-show="foldType" style="display: flex;justify-content:left;align-items: center;flex-wrap: wrap">
          <div v-for="(item,index) in specialZoneList.slice(1)" :key="item.id" :style="(index + 1) %5 === 0 ? '' : 'margin-right: 24px'" style="margin-bottom: 24px" @click="switchZone(item)">
            <div style="width: 180px;height: 64px;border-radius: 2px 2px 2px 2px;border: 1px solid #DCDCDC;position: relative;overflow: hidden"  >
              <div class="isSelected" v-if="registerList.zoneId === item.id" style=""></div>
              <div>
                <div v-if="item.id === '0'">
                  <img :src="item.navigationLogo">
                </div>
                <Picture v-else :file-id="item.navigationLogo" style="width: 100%;height: 100%"></Picture>
              </div>
            </div>
          </div>
        </div>
<!--        <el-collapse value="1" >-->
<!--          <el-collapse-item title="其它业主采购专区" name="1">-->
<!--            <template slot="title">-->
<!--              <div style="font-size: 18px;color: #333333;">其它业主采购专区</div>-->
<!--            </template>-->
<!--            <div style="display: flex;justify-content:left;align-items: center;flex-wrap: wrap">-->
<!--              <div v-for="(item,index) in specialZoneList.slice(1)" :key="item.id" :style="(index + 1) %5 === 0 ? '' : 'margin-right: 24px'" style="margin-bottom: 24px" @click="switchZone(item)">-->
<!--                <div style="width: 180px;height: 64px;border-radius: 2px 2px 2px 2px;border: 1px solid #DCDCDC;position: relative;overflow: hidden"  >-->
<!--                  <div class="isSelected" v-if="registerList.zoneId === item.id" style=""></div>-->
<!--                  <div>-->
<!--                    <div v-if="item.id === '0'">-->
<!--                      <img :src="item.navigationLogo">-->
<!--                    </div>-->
<!--                    <Picture v-else :file-id="item.navigationLogo" style="width: 100%;height: 100%"></Picture>-->
<!--                  </div>-->
<!--                </div>-->
<!--              </div>-->
<!--            </div>-->
<!--          </el-collapse-item>-->
<!--        </el-collapse>-->
      </div>
      <div style="text-align: center">
        <el-button style="background: #FF8A00;border-radius: 2px 2px 2px 2px;font-size: 20px;color: #FFFFFF;padding: 12px 33px" type="" @click="confirmZone">确认专区</el-button>
      </div>
    </el-dialog>
    <el-dialog center   :visible.sync="applyForDiong" width="920px" append-to-body custom-class="sqzq">
      <div style="display:flex;justify-content: space-between;align-items: center">
        <div style="width: calc(100% - 520px)"></div>
        <div style="width: 450px">
          <div style="font-size: 24px;color: #000000;margin-bottom: 16px">欢迎企业咨询</div>
          <div style="font-size: 14px;color: #999999;margin-bottom: 16px">完善角色信息有助于我们提供更佳的服务方案</div>
          <div style="width: 384px">
            <el-form style="width: 100%;" ref="applyForm" :model="applyForm" :rules="rules" label-width="20px" class="sqzqfrom">
              <el-form-item label=" " prop="phone">
                <el-input v-model="applyForm.phone" placeholder="手机号"></el-input>
              </el-form-item>
              <el-form-item label=" " prop="userName">
                <el-input v-model="applyForm.userName" placeholder="姓名"></el-input>
              </el-form-item>
              <el-form-item label=" " prop="enterpriseName">
                <el-input v-model="applyForm.enterpriseName" placeholder="公司"></el-input>
              </el-form-item>
                  <Verify
                    ref="verify"
                    :img-size="{width:'400px',height:'200px'}"
                    @success="sqzqSubmit"
                  />
              <el-form-item label=" " prop="position">
                <el-input v-model="applyForm.position" placeholder="职务"></el-input>
              </el-form-item>
              <el-form-item label=" " prop="budgetScope">
                <el-input v-model="applyForm.budgetScope" placeholder="预算范畴"></el-input>
              </el-form-item>
            </el-form>
            <div style="text-align: center;">
              <el-button @click.stop="checkCaptcha" style="background: #FF8A00;border-radius: 2px ;padding: 13px 60px 13px;font-size: 20px;color: #FFFFFF;">立即提交</el-button>
            </div>
          </div>
        </div>
      </div>
    </el-dialog>
    <el-dialog center   :visible.sync="applyForhzDiong" width="920px" append-to-body custom-class="qyhz">
      <div style="display:flex;justify-content: space-between;align-items: center">
        <div style="width: calc(100% - 520px)"></div>
        <div style="width: 450px;margin-top: 83px">
            <div style="font-size: 24px;color: #000000;margin-bottom: 14px;text-align: center">欢迎，区域合作商</div>
            <div style="font-size: 14px;color: #999999;margin-bottom: 71px;text-align: center">我们会有专业人员在第一时间与您取得联系</div>
            <div style="width: 384px;">
              <el-form style="width: 100%;" ref="applyForm" :model="applyForm" :rules="rules" label-width="80px" class="qyhzfrom">
                <el-form-item label="联系人" prop="userName">
                  <el-input v-model="applyForm.userName" placeholder="请输入联系人"></el-input>
                </el-form-item>
                <el-form-item label="联系方式" prop="phone">
                  <el-input v-model="applyForm.phone" placeholder="请输入联系方式"></el-input>
                </el-form-item>
              </el-form>
              <div style="text-align: center;">
                <el-button @click.stop="qyhzSubmit" style="background: #0048FF;border-radius: 2px ;padding: 13px 60px 13px;font-size: 20px;color: #FFFFFF;">申请入驻</el-button>
              </div>
            </div>

        </div>
      </div>
    </el-dialog>
    <el-dialog  title="系统通知"  :visible.sync="promptDiong" width="400px"  append-to-body >
      <div>此系统为测试系统，点击此处跳往“<span style="color: #0a84ff;cursor: pointer" @click="goToFormal">正式系统</span>”</div>
    </el-dialog>
    <el-dialog  title="监督系统"  :visible.sync="jdDiong" width="800px" append-to-body >
      <div style="display: flex;justify-content: space-between;align-items: center;cursor: pointer">
        <div v-for="item in logOn.slice(2,4)" :key="item.title" @click="goToLogin(item)">
          <el-image style="width:326px;height: 88px " :src="item.icon"></el-image>
        </div>
      </div>
    </el-dialog>
    <el-dialog :visible.sync="promotionDialog" width="896px;" custom-class="promotionDialog" :show-close="false">
      <template #title>
        <div style="display: flex;justify-content: space-between">
          <div style="padding: 18px 0 0 26px;box-sizing: border-box" >
            <div style="font-size: 36px;color: #F45A21;font-weight: bold;margin-bottom: 12px">远程视频监督功能全新上线</div>
            <div style="background: linear-gradient( 90deg, #F45A21 0%, #F45F24 7.14%, #F56326 14.29%, #F56729 21.43%, #F66C2B 28.57%, #F6702D 35.71%, #F67430 42.86%, #F77832 50%, #F77C34 57.14%, #F78036 64.29%, #F78438 71.43%, #F8883B 78.57%, #F88C3D 85.71%, #F88F3F 92.86%, #F89341 100%);
                        box-shadow: 0px 1px 2px -1px rgba(0,0,0,0.1), 0px 1px 3px 0px rgba(0,0,0,0.1);border-radius: 60px 60px 60px 60px;padding: 6px 16px;box-sizing: border-box;font-size: 16px;color: #FFFFFF;">
              限时免费福利：前5名代理用户，免费申领设备，体验高效监督功能
            </div>
          </div>
          <el-image @click="promotionDialog = false" style="width: 36px;height: 36px;cursor: pointer" :src="require('@/assets/images/lb/promotionGb.png')"></el-image>
        </div>
      </template>
      <div style="">
        <div style="width: 817px;height: 127px;background: #FFFFFF;box-shadow: 0px 1px 2px -1px rgba(0,0,0,0.1), 0px 1px 3px 0px rgba(0,0,0,0.1);border-radius: 14px 14px 14px 14px;border: 1px solid #FFE4C4;
                    display: flex;justify-content: left;align-items: center;margin-bottom: 32px">
          <div style="width: 6px;height: 125px;background: #F45A21;border-radius: 14px 0px 0px 14px;"></div>
          <div style="padding: 20px 21px;box-sizing: border-box">
            <div style="font-size: 20px;color: #F45A21;margin-bottom: 7px">远程视频监督系统</div>
            <div style="font-size: 15px;color: #584D4A;">支持远程开评标监督、专家抽取过程监督，招投标过程文件查看权限等，打破空间限制，支持招标代理一键邀请，远程实时视频参与。降低沟通成本保留云端存证。全程可视、规范透明，让招标流程更高效、更省心</div>
          </div>
        </div>
        <div style="display: flex;justify-content: left;align-items: center;margin-bottom: 17px">
          <div style="width: 8px;height: 8px;background: #F89341;border-radius: 25px;margin-right:8px"></div>
          <div style="font-weight: bold;font-size: 18px;color: #333333;">核心监督功能详解</div>
        </div>
        <div style="display: flex;justify-content: space-between;align-items: center;margin-bottom: 20px;width: 817px;">
          <div style="width: 399px;height: 152px;background: #FFFFFF;border-radius: 14px 14px 14px 14px;border: 1px solid #FFEDD5;padding: 21px;box-sizing: border-box">
            <div style="display: flex;justify-content: left;align-items: center;margin-bottom: 16px">
              <el-image style="width: 48px;width: 48px;margin-right: 12px" :src="require('@/assets/images/lb/promotionKBJD.png')"></el-image>
              <div style="font-weight: bold;font-size: 18px;color: #1E2939;">开标监督</div>
            </div>
            <div style="font-weight: 400;font-size: 14px;color: #4A5565;">支持开标大厅页面数据监督与开标区域视频监控双模式独立配置，实现开标环节全场景可视化监管。</div>
          </div>
          <div style="width: 399px;height: 152px;background: #FFFFFF;border-radius: 14px 14px 14px 14px;border: 1px solid #FFEDD5;padding: 21px;box-sizing: border-box">
            <div style="display: flex;justify-content: left;align-items: center;margin-bottom: 16px">
              <el-image style="width: 48px;width: 48px;margin-right: 12px" :src="require('@/assets/images/lb/promotionpbjd.png')"></el-image>
              <div style="font-weight: bold;font-size: 18px;color: #1E2939;">评标监督</div>
            </div>
            <div style="font-weight: 400;font-size: 14px;color: #4A5565;">支持评标进度监督与评标区域视频监控独立配置，保障评标过程规范、可控、可追溯。</div>
          </div>
        </div>
        <div style="display: flex;justify-content: space-between;align-items: center;width: 817px;">
          <div style="width: 399px;height: 152px;background: #FFFFFF;border-radius: 14px 14px 14px 14px;border: 1px solid #FFEDD5;padding: 21px;box-sizing: border-box">
            <div style="display: flex;justify-content: left;align-items: center;margin-bottom: 16px">
              <el-image style="width: 48px;width: 48px;margin-right: 12px" :src="require('@/assets/images/lb/promotionYZZS.png')"></el-image>
              <div style="font-weight: bold;font-size: 18px;color: #1E2939;">业主资格审查</div>
            </div>
            <div style="font-weight: 400;font-size: 14px;color: #4A5565;">针对招标文件中已预设业主资格审查流程的招标项目，提供全过程线上监督与留痕管理</div>
          </div>
          <div style="width: 399px;height: 152px;background: #FFFFFF;border-radius: 14px 14px 14px 14px;border: 1px solid #FFEDD5;padding: 21px;box-sizing: border-box">
            <div style="display: flex;justify-content: left;align-items: center;margin-bottom: 16px">
              <el-image style="width: 48px;width: 48px;margin-right: 12px" :src="require('@/assets/images/lb/promotionzjcq.png')"></el-image>
              <div style="font-weight: bold;font-size: 18px;color: #1E2939;">专家抽取过程监督</div>
            </div>
            <div style="font-weight: 400;font-size: 14px;color: #4A5565;">支持自定义选定监督标室、绑定抽取现场监控摄像头，可灵活配置监督人是否具备抽取桌面查看权限</div>
          </div>
        </div>
      </div>
      <template #footer>
        <div style="display: flex;justify-content: space-between;align-items: center">
          <div>
            <div style="font-size: 14px;color: #6A7282;margin-bottom: 3px;">名额有限，申请即享专属技术支持</div>
            <div style="display: flex;justify-content: center;align-items: center;width: 205px;height: 31px;background: #FFF0DD;border-radius: 8px 8px 8px 8px;">
              <el-image style="width: 16px;height: 16px;margin-right: 6px" :src="require('@/assets/images/lb/promotionJG.png')"></el-image>
              <div style="font-weight: bold;;font-size: 15px;color: #F45A21;">0元免费试用设备及系统</div>
            </div>

          </div>
          <div  style="width: 274px;height: 56px;background: linear-gradient( 93deg, #F45920 0.42%, #F89341 96.17%);box-shadow: 0px 2px 4px -4px rgba(244,90,33,0.3), 0px 10px 15px -3px rgba(244,90,33,0.3);border-radius: 90px 90px 90px 90px;text-align: center;line-height: 56px;
                      font-size: 20px;color: #FFFFFF;cursor: pointer">联系客服：400-666-0654</div>
        </div>
      </template>
    </el-dialog>
  </div>
</template>

<script>
import {
  xinwenlist,
  toolslist,
  getRegionYzApi,
  lbimagesApi,enterpriseApi, getGgListNoPageApi
} from "@/api/api";
import { home } from '@/utils/images'
import Picture from "@/components/picture/picture.vue";
import {getCodeImg} from "@/api/login";
import qyhzs from "@/assets/images/homeImages/qyhzs.png";
import Verify from "@/components/captcha/Verify.vue";
import { checkCaptcha } from "@/api/captcha";
import ycjd from '@/assets/images/lb/ycjd.png'
export default {
  computed: {
    qyhzs() {
      return qyhzs
    }
  },
  components: {Picture, Verify},

  data() {
    return {
      ycjd,
      home:home,
      imagelist: [],
      ggType:[
        {label: "招标公告",  value: 'zbgg'},
        {label: "变更公告",  value: 'bggg'},
        {label: "资格预审公告",  value: 'zgysgg'},
        {label: "中标候选人公示",  value: 'zbhxrgs'},
        {label: "中标公告",  value: 'zhongbiaogg'},
        {label: "招标预告",  value: 'zbyg'},
        {label: "合同公示",  value: 'htgs'},
        {label: "供应商征集",  value: 'GYS'},
        {label: "专家征集",  value: 'ZJ'},
      ],
      noticeQueryParam:{pageSize: 10, page: 1,ggAnnouncement:'zbgg'},
      ggList:[],
      logOn: [
        {icon:home.dl , title: "代理机构登录", path: "/login",type:'3',isShow:true},
        {icon:home.tbr , title: "投标人登录", path: "/login",type:'2',isShow:true },
        {icon:home.jdZs, title: "监督/资审通道(新)", path: "/supervise",isShow:false},
        {icon:home.jd, title: "监督系统登录", path: "/superviseLinks",isShow:true},
        {icon: home.owner, title: "业主登录", path: "/login",type:'1',isShow:false},
        {icon: home.pb, title: "评标专家登录", path: "/PBLoginMain",isShow:true},
      ],
      specialZoneList:[],
      registerDiong: false,
      registerList:{type:'',zoneId:'0'},

      xwlist: [],
      toollist: [],
      toolaction: '',
      applyForm:{phone:'',userName:'',enterpriseName:'',code:'',position:'',budgetscope:''},
      applyForDiong:false,
      rules:{
        phone:[  { required: true, message: "请输入联系电话", trigger: "blur" },
          {pattern: /^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/, message: "请输入正确的手机号", trigger: "blur",},],
        userName:[  { required: true, message: "请输入姓名", trigger: "blur" },],
        enterpriseName:[  { required: true, message: "请输入公司名称", trigger: "blur" },],
      },
      foldType:true,
      applyForhzDiong:false,
      promptDiong:false,
      jdDiong:false,
      promotionDialog:false,
      smVisible: true,
      smNoRemindToday: false
    };
  },
  created() {

  },
  mounted() {
    this.lb()
    this.getGgList()
    this.xinwen()
    this.tools()
    this.getRegionYz()
    if(location.host === 'test.gzzczb.com'){
      this.promptDiong = true
    }
    const noRemind = localStorage.getItem('smNoRemindToday')
    const today = new Date().toDateString()
    if(noRemind === today){
      this.smVisible = false
    }
  },
  methods: {
    sm(){
      if(this.smNoRemindToday){
        localStorage.setItem('smNoRemindToday', new Date().toDateString())
      }
      this.smVisible = false
      window.open('https://www.gzzczb.com/app/%E5%A3%B0%E6%98%8E.html','_blank')
    },
    /**
     * 轮播图
     * @returns {Promise<void>}
     */
    async lb() {
      const { data } = await  lbimagesApi()
      this.imagelist = data.items
      this.imagelist.splice(1,0,{pictureUrl:ycjd,jumpAddress:'ycjd'})
    },
    carouselClick(item){
      if(item.jumpAddress === 'ycjd'){
        this.promotionDialog = true
        return
      }
      window.open(item.jumpAddress, '_blank');
    },
    /**
     * 获取公告列表
     *
     */
    async getGgList() {
      const {data} = await getGgListNoPageApi(this.noticeQueryParam)
      this.ggList = data || []
    },
    switchGGType(val){
      this.noticeQueryParam.ggAnnouncement = val.value
      this.getGgList()
    },
    ggDetail(val){
      if (val.srcUrl) {
        window.open(val.srcUrl, '_blank');
        return
      }
      let path = '/ggDetail'
      if(val.zoneId){
        path = '/zone/ggDetailZone'
        if(this.noticeQueryParam.ggAnnouncement === 'GYS' || this.noticeQueryParam.ggAnnouncement === 'ZJ'){
          path = '/zone/collectGgDetail'
        }
      }
      this.$router.push({path: path, query: {id: val.id,zoneId: val.zoneId}});
    },
    /**
     * 登录
     */
    async logOnClick(val){
      if(val.path !== '/login' || val.type === '3'){
        if(val.path === '/PBLoginMain'){
          let url = location.origin + `${process.env.VUE_APP_PB_LOGOION}index.html#/login`
          window.open(url, '_blank');
          return
        }
        if(val.path === '/superviseLinks'){
          this.jdDiong = true
          return
        }
       await this.$router.push({path: val.path,query:{type:val.type} })
      }else {
        this.registerDiong = true
        this.registerList = {type:val.type,zoneId:'0'}
      }
    },
    async goToLogin(val){
      if(val.path === '/supervise'){
        let url = `https://supervise.gzzczb.com/#/login`
        window.open(url, '_blank');
      }
      await this.$router.push({path: val.path,query:{type:val.type} })
    },
    switchZone(val){
      this.registerList.zoneId = val.id
    },
    confirmZone(){
      if(this.registerList.zoneId === '0'){
        this.$router.push({path: '/login', query: {type:this.registerList.type}});
      }else {
        let routeData = this.$router.resolve({path: "/LoginZone", query: {type:this.registerList.type,zoneId:this.registerList.zoneId}});
        window.open(routeData.href, '_blank');
      }
    },
    /**
     * 新闻公告
     * @returns {Promise<void>}
     */
    async xinwen() {
      const {data} = await xinwenlist()
      this.xwlist =data.items
    },

    goNewsDetail(id) {
      let routeData = this.$router.resolve({path: "/newsDetail", query: {id: id}});
      window.open(routeData.href, '_blank');
    },
    /**
     * 工具下载
     * @returns {Promise<void>}
     */
    async tools() {
      const {data} = await toolslist()
      this.toollist = data.items
    },
    downloadClick(row) {
      window.open(row.commonTool)
    },
    /**
     * 专区信息
     * @returns {Promise<void>}
     */
    async getRegionYz(){
      const {data} = await getRegionYzApi()
      this.specialZoneList =  [{id:'0',name:'国资智采',navigationLogo:home.gzzc},...data,]
    },

    /**
     * 打开新页面
     * @param val
     */
    toPath(val){
      this.$router.push({path: val,})
    },
    toRouter(val){
      let routeData = this.$router.resolve({path: val,});
      window.open(routeData.href, '_blank');
    },
    /**
     * 申请专区
     */
    applyFor(){
      this.applyForm = {phone:'',userName:'',enterpriseName:'',code:'',uuid:'',settledType:'T'}
      this.applyForDiong = true
      this.getCode();
    },
    async getCode() {
      const res = await getCodeImg()
      this.captchaOnOff = res.captchaOnOff === undefined ? true : res.captchaOnOff;
      if (this.captchaOnOff) {
        this.$set(this.applyForm, 'codeUrl', "data:image/gif;base64," + res.data.img)
        this.$set(this.applyForm, 'uuid', res.data.uuid)
      }
    },
    checkCaptcha() {
      this.$refs.applyForm.validate(valid => {
        if (valid) {
          this.$refs.verify.show()
        }        
      })
    },
    sqzqSubmit(verified){
      this.$refs.applyForm.validate((valid) => {
        if(valid){
          this.applyForm.captchaVerification = verified.captchaVerification
          this.applyForm.uuid = undefined
          this.applyForm.code = undefined
          enterpriseApi(this.applyForm).then(res =>{
            this.$message.success('提交成功')
            this.applyForm = {}
            this.applyForDiong = false
          })
        }
      });
    },
    applyForhz(){
      this.applyForm = {phone:'',userName:'',settledType:'P'}
      this.applyForhzDiong = true
    },
    qyhzSubmit(){
      this.$refs.applyForm.validate((valid) => {
        if(valid){
          enterpriseApi(this.applyForm).then(res =>{
            this.$message.success('提交成功')
            this.applyForm = {}
            this.applyForhzDiong = false
          })
        }
      });
    },
    goToFormal(){
      window.open('https://www.gzzczb.com/home','_blank')
    }
  },
};
</script>
<style scoped>
.page_home{
  padding-bottom: 50px;
  box-sizing: border-box;
}
.page_header{
  width: 100%;
  height: 390px;
  margin: 0 auto;
}
.home_lunbo{
  width: 100%;

}
.page_content{
  width: 1360px;
  margin: 0 auto;
  padding: 32px 0;;
  border: 1px solid #0000;
}
.home_content{
  display: flex;
  width: 100%;
  justify-content: space-between;
}
.ptjxxx{
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 24px 28px;
  background: url('@/assets/images/homeImages/jyxx.png') no-repeat;
  background-size:cover;
  background-position: center;
}
.xtdlrk{
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 24px 20px;
  background: url('@/assets/images/homeImages/xtdlrk.png') no-repeat;
  background-size:cover;
  background-position: center;
}
.news_list li {
  cursor: pointer;
}

.news_list li:hover .con_h{
  color: #F18C1D;
}
.con_h {
  font-size: 100%;
  margin-bottom: 10px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.toolitem{
  background-color:#ffffff;
  transition:all 0.5s;
  width: 326px;
  padding: 8px 12px;
  border: 1px solid #EEEEEE;
  border-radius: 4px;

  margin: 0 auto 16px;
  cursor: pointer;
  color: #333333;
}






.headerTitleClass2 {
  padding-left: 17px;
  padding-bottom: 18px;
  border-bottom: 1px solid #eee;
  position: relative;
  margin-bottom: 18px;
}
.headerTitleClass2::before {
  content: '';
  width: 6px;
  height: 22px;
  background: #F18C1D;
  position: absolute;
  left: 0;
  top: 2px;
}


.card1 {
  height: 160px;
  width: 100%;
  margin: 32px auto;
}
h3{
  color: #F18C1D;
}
.block{
  width: 100%;
}
.isSelected{
  background: url('@/assets/images/homeImages/xz.png') no-repeat;
  background-size:cover;
  background-position: center;
  width: 180px;
  height: 64px;
  position: absolute;
  top: 0;
  z-index: 99;
}
::v-deep .sqzq{
  height: 620px !important;
  background: url('@/assets/images/homeImages/sqzqdiong.png') no-repeat;
  background-size:cover;
  background-position: center;
  box-shadow: none;
}
::v-deep .sqzqfrom .el-form-item{
    border-bottom: 1px solid #DCDCDC !important;
}
::v-deep .sqzqfrom .el-input__inner{
  border: none !important;
}
.login-code-img {
  height: 40px;
  width: 95px;
  margin-left: 10px;
}
::v-deep .el-collapse{
  border: none !important;
}
::v-deep .el-collapse-item__wrap{
  border: none !important;
}
::v-deep .qyhz{
  height: 620px !important;
  background: url('@/assets/images/homeImages/qyhzdiong.png') no-repeat;
  background-size:cover;
  background-position: center;
  box-shadow: none;
}
::v-deep .wh{
  border-radius: 20px 20px 20px 20px !important;
}
::v-deep .wh .el-dialog__header{
  border-radius: 20px 20px 0px 0px !important;
  background: url('@/assets/images/tj/tjbj.png') no-repeat;
  background-size:cover;
  background-position: center;
  box-shadow: none;
  height: 120px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  color: #ffffff;
}
::v-deep .promotionDialog{
  margin: 30px  auto !important;
  border-radius: 16px 16px 16px 16px;
}
::v-deep .promotionDialog .el-dialog__header{
  height: 156px;
  background: url("@/assets/images/lb/promotionHeaderbj.png") no-repeat;
  background-size: cover;
  background-position: center center;
  box-sizing: border-box;
  border-radius: 16px 16px 0 0 ;
}
::v-deep .promotionDialog .el-dialog__body{
  padding: 28px 32px !important;
  background: #FFFCF8;
  box-sizing: border-box;
}
.sm-card{
  position: fixed;
  left: 8px;
  top: auto;
  bottom: 24px;
  transform: none;
  width: 260px;
  height: 166px;
  background: #FFFFFF;
  box-shadow: 0px 0px 8px 0px rgba(108,58,57,0.15);
  border-radius: 10px;
  z-index: 999;
  overflow: hidden;
}
.sm-card-header{
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px 16px 8px;
}
.sm-card-title{
  font-size: 16px;
  font-weight: normal;
  color: #333333;
}
.sm-card-close{
  opacity: 0.5;
}
.sm-card-close:hover{
  opacity: 1;
}
.sm-card-body{
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 4px 16px 12px;
  border-bottom: 1px dashed #DCDCDC;
}
.sm-card-text-main{
  font-size: 16px;
  font-weight: bold;
  color: #333333;
  line-height: 1.6;
  white-space: nowrap;
}
.sm-card-text-sub{
  font-size: 12px;
  color: #666666;
  margin-top: 4px;
}
.sm-card-illustration{
  width: 72px;
  height: 72px;
  flex-shrink: 0;
}
.sm-card-footer{
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 8px 16px 14px;
}
.sm-card-checkbox{
  font-size: 12px;
  color: #666666;
  cursor: pointer;
  display: flex;
  align-items: center;
}
.sm-card-checkbox input{
  margin-right: 4px;
  cursor: pointer;
}
.sm-card-btn{
  background: #E53935 !important;
  color: #FFFFFF !important;
  font-size: 13px;
  padding: 4px 12px;
  border-radius: 4px;
}
.sm-card-btn:hover{
  opacity: 0.85;
}
</style>
